import { QuestionnaireVersion } from '../../models/Questionnaire';

export const checkIsTryingEditingPublishedWhenDraftIsDifferent = findersState =>
  findersState.selectedQuestionnaireVersion === QuestionnaireVersion.PUBLISHED &&
  findersState.finder?.questionnaire !== findersState.finder?.questionnaireDraft;
